<template>
  <div class="admin-page">
    <Header />
    <div class="header-actions">
      <h2 class="title"><i class="fa-solid fa-calculator"></i> Simulador de Vendas</h2>
      <router-link to="/admin/dashboard" class="btn-back">Voltar ao Painel</router-link>
    </div>

    <div class="simulator-layout">
      <!-- Configurações da Simulação -->
      <div class="card-panel config-panel">
        <h3>Opções do Pacote</h3>
        
        <div class="form-group">
          <label>Modalidade de Venda</label>
          <div style="display: flex; gap: 15px; margin-bottom: 15px; margin-top: 5px;">
            <label class="checkbox-label" style="margin:0;">
              <input type="radio" v-model="simulation.purchase_mode" value="exact" /> Por Acessos Exatos
            </label>
            <label class="checkbox-label" style="margin:0;" v-if="volumeTiers.length > 0">
              <input type="radio" v-model="simulation.purchase_mode" value="tier" /> Lote Fechado (Por Faixa)
            </label>
          </div>
        </div>

        <div class="form-group" v-if="simulation.purchase_mode === 'exact'">
          <label>Quantidade Estimada de Acessos (Alunos)</label>
          <input type="number" v-model.number="simulation.accesses" class="input-sim" min="1" />
        </div>

        <div class="form-group" v-else>
          <label>Selecione a Faixa de Acessos (Lote Máximo)</label>
          <select v-model.number="simulation.selected_tier_index" class="input-sim" style="color: #000; background: #fff;">
            <option v-for="(tier, index) in volumeTiers" :key="index" :value="index">
              Faixa: {{ tier.min }} a {{ tier.max }} acessos ({{ tier.discount }}% OFF)
            </option>
          </select>
        </div>

        <h4>Quais materiais o parceiro deseja?</h4>
        
        <div class="material-options">
          <label class="checkbox-label">
            <input type="checkbox" v-model="simulation.wants_full_books" /> 
            Todos os Livros Completos
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="simulation.wants_full_videos" /> 
            Todos os Vídeos Completos
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="simulation.wants_full_simulated" /> 
            Todos os Simulados Completos
          </label>
          
          <hr class="divider"/>
          
          <label class="checkbox-label">
            <input type="checkbox" v-model="simulation.wants_combo_vip" /> 
            Combo Total VIP (Tudo Incluso)
          </label>
        </div>

        <div class="material-options" v-if="!simulation.wants_combo_vip">
          <hr class="divider"/>
          <h4>Ou Materiais Avulsos (Quantidades de Itens)</h4>
          <div class="form-group-inline">
            <label>Nº de Livros Avulsos:</label>
            <input type="number" v-model.number="simulation.qty_single_books" min="0" class="input-small" />
          </div>
          <div class="form-group-inline">
            <label>Nº de Vídeos Avulsos:</label>
            <input type="number" v-model.number="simulation.qty_single_videos" min="0" class="input-small" />
          </div>
          <div class="form-group-inline">
            <label>Nº de Simulados Avulsos:</label>
            <input type="number" v-model.number="simulation.qty_single_simulated" min="0" class="input-small" />
          </div>
        </div>

        <div class="form-group discount-group">
          <div v-if="appliedVolumeDiscount > 0" style="margin-bottom: 15px; padding: 10px; background: rgba(46, 204, 113, 0.1); border-left: 3px solid #2ecc71; border-radius: 4px; color: #2ecc71;">
            <i class="fas fa-tags"></i> Desconto de Lote aplicado: <strong>{{ appliedVolumeDiscount }}% OFF</strong>
          </div>
          <label>Desconto Adicional de Negociação (%)</label>
          <input type="number" v-model.number="simulation.discount_percent" class="input-sim" min="0" max="100" />
        </div>
      </div>

      <!-- Resultado da Simulação (Visualização em Tela) -->
      <div class="card-panel result-panel">
        
        <div class="screen-preview">
          <div class="pdf-header">
            <h3>Proposta Comercial (Simulação)</h3>
            <p>Data: {{ new Date().toLocaleDateString('pt-BR') }}</p>
          </div>
          
          <div style="text-align: center; margin-bottom: 15px;">
            <p style="margin: 0; font-size: 1.1rem; color: #fff;">Total Líquido Anual: <strong>R$ {{ calculatedTotal.toFixed(2).replace('.', ',') }}</strong></p>
          </div>
          <div class="result-price" style="font-size: 2.2rem; display: flex; flex-direction: column; align-items: center;">
            <span style="font-size: 1.2rem; color: #fff; margin-bottom: 5px;">Investimento Mensal (12x)</span>
            <span>R$ {{ calculatedTotalMonthly.toFixed(2).replace('.', ',') }}</span>
          </div>
          <div class="result-breakdown">
            <p><strong>Detalhamento do Pacote Comercial:</strong></p>
            <ul>
              <li><strong>Volume de Licenças (Alunos):</strong> {{ effectiveAccesses }} acessos <span v-if="simulation.purchase_mode === 'tier'" class="text-highlight">(Lote Fechado)</span></li>
              <li v-if="simulation.wants_combo_vip"><strong>Plano:</strong> Combo Total VIP (Acesso Irrestrito)</li>
              <li v-if="simulation.wants_full_books && !simulation.wants_combo_vip"><strong>Acervo Completo de Livros</strong></li>
              <li v-if="simulation.wants_full_videos && !simulation.wants_combo_vip"><strong>Acervo Completo de Vídeos</strong></li>
              <li v-if="simulation.wants_full_simulated && !simulation.wants_combo_vip"><strong>Acervo Completo de Simulados</strong></li>
              <li v-if="simulation.qty_single_books > 0 && !simulation.wants_combo_vip">Livros Avulsos: {{ simulation.qty_single_books }} unidades</li>
              <li v-if="simulation.qty_single_videos > 0 && !simulation.wants_combo_vip">Vídeos Avulsos: {{ simulation.qty_single_videos }} unidades</li>
              <li v-if="simulation.qty_single_simulated > 0 && !simulation.wants_combo_vip">Simulados Avulsos: {{ simulation.qty_single_simulated }} unidades</li>
              
              <li v-if="appliedVolumeDiscount > 0" class="text-highlight">
                <strong>Desconto Automático por Lote ({{ effectiveAccesses }} un.):</strong> {{ appliedVolumeDiscount }}% OFF
              </li>
              <li v-if="simulation.discount_percent > 0" class="text-highlight">
                <strong>Desconto Adicional de Negociação:</strong> {{ simulation.discount_percent }}% OFF
              </li>
            </ul>
            <p class="note">* Valores válidos para fechamento da proposta sob as condições quantitativas negociadas.</p>
          </div>
        </div>
        
        <button class="btn-primary w-100" @click="generatePDF" :disabled="isGeneratingPDF">
          <i class="fa-solid fa-file-pdf"></i> {{ isGeneratingPDF ? 'Gerando PDF Profissional...' : 'Baixar Proposta em PDF' }}
        </button>
      </div>
    </div>

    <!-- Layout Oculto Exclusivo para Exportação em PDF -->
    <div style="overflow: hidden; height: 0; width: 0;">
      <div ref="pdfContent" id="pdf-export-template" style="width: 800px; background: white; color: #333; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; box-sizing: border-box; position: relative; min-height: 1120px;">
        
        <!-- Header -->
        <div style="background: #09105D; padding: 40px; text-align: center; border-bottom: 5px solid #FEC401;">
          <img src="../../../src/assets/logos/logo-branco.png" alt="EDUCAMAIS - Projeto ASAS" style="max-height: 70px; margin-bottom: 15px;" />
          <h2 style="color: #ffffff; margin: 0; font-size: 24px; letter-spacing: 2px; font-weight: 600;">PROPOSTA COMERCIAL</h2>
        </div>

        <!-- Body -->
        <div style="padding: 40px 50px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-end; border-bottom: 2px solid #eee; padding-bottom: 15px; margin-bottom: 30px;">
            <h3 style="color: #09105D; margin: 0; font-size: 20px;">Detalhamento da Simulação</h3>
            <p style="color: #666; font-size: 14px; margin: 0;">Data de emissão: <strong>{{ new Date().toLocaleDateString('pt-BR') }}</strong></p>
          </div>
          
          <table style="width: 100%; border-collapse: collapse; font-size: 14px; margin-bottom: 40px;">
            <thead>
              <tr>
                <th style="padding: 15px; background: #f8f9fa; border: 1px solid #e0e0e0; text-align: left; color: #09105D; font-weight: bold;">Produto / Pacote Selecionado</th>
                <th style="padding: 15px; background: #f8f9fa; border: 1px solid #e0e0e0; text-align: center; color: #09105D; font-weight: bold; width: 180px;">Volume de Acessos</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Combo Total VIP (Acesso Irrestrito à Plataforma)</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
              <tr v-if="simulation.wants_full_books && !simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Pacote Fechado: Acervo Completo de Livros Digitais</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
              <tr v-if="simulation.wants_full_videos && !simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Pacote Fechado: Acervo Completo de Videoaulas</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
              <tr v-if="simulation.wants_full_simulated && !simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Pacote Fechado: Banco Completo de Simulados</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
              <tr v-if="simulation.qty_single_books > 0 && !simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Livros Avulsos Selecionados ({{ simulation.qty_single_books }} unidades)</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
              <tr v-if="simulation.qty_single_videos > 0 && !simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Vídeos Avulsos Selecionados ({{ simulation.qty_single_videos }} unidades)</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
              <tr v-if="simulation.qty_single_simulated > 0 && !simulation.wants_combo_vip">
                <td style="padding: 15px; border: 1px solid #e0e0e0; color: #444;">Simulados Avulsos Selecionados ({{ simulation.qty_single_simulated }} unidades)</td>
                <td style="padding: 15px; border: 1px solid #e0e0e0; text-align: center; color: #444;">{{ effectiveAccesses }} alunos <span v-if="simulation.purchase_mode === 'tier'"><br/><small style="color: #888;">(Lote Fechado)</small></span></td>
              </tr>
            </tbody>
          </table>

          <!-- Finance Summary -->
          <div style="display: flex; justify-content: flex-end;">
            <div style="width: 380px; background: #fff; padding: 25px; border: 1px solid #e0e0e0; border-radius: 8px; border-left: 5px solid #09105D; box-shadow: 0 4px 10px rgba(0,0,0,0.03);">
              
              <div v-if="appliedVolumeDiscount > 0" style="display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 14px;">
                <span style="color: #666;">Desconto por Lote (Escala):</span> 
                <span style="color: #e74c3c; font-weight: bold;">- {{ appliedVolumeDiscount }}% OFF</span>
              </div>
              
              <div v-if="simulation.discount_percent > 0" style="display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 14px;">
                <span style="color: #666;">Desconto de Negociação:</span> 
                <span style="color: #e74c3c; font-weight: bold;">- {{ simulation.discount_percent }}% OFF</span>
              </div>
              
              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px; padding-top: 15px; border-top: 2px solid #eee;">
                <span style="color: #666; font-size: 14px; font-weight: bold;">Total Líquido Anual:</span> 
                <span style="color: #444; font-size: 16px; font-weight: 800;">{{ calculatedTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px; padding-top: 10px; border-top: 1px dashed #eee;">
                <span style="color: #09105D; font-size: 16px; font-weight: bold;">Mensalidade (12x):</span> 
                <span style="color: #2ecc71; font-size: 24px; font-weight: 800;">{{ calculatedTotalMonthly.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div style="position: absolute; bottom: 50px; left: 50px; right: 50px; text-align: center;">
          <div style="width: 300px; border-top: 1px solid #ccc; margin: 0 auto 10px auto;"></div>
          <p style="margin: 0 0 20px 0; font-weight: bold; color: #09105D; font-size: 14px; text-transform: uppercase; letter-spacing: 1px;">Aprovação Comercial - Projeto Asas</p>
          <p style="margin: 0; font-size: 12px; color: #777; line-height: 1.6;">
            Esta proposta comercial foi elaborada com base em simulação gerencial e possui validade de 10 (dez) dias a partir de sua emissão.<br/>
            Após a aprovação da proposta e a assinatura do Contrato de Prestação de Serviços, serão iniciados os procedimentos de implantação e a liberação oficial dos acessos à plataforma.
          </p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import requestV2 from '@/router/requestV2.js';
import '@/styles/Admin.css';
import html2pdf from 'html2pdf.js';

export default {
  name: 'AdminSimulator',
  components: { Header },
  data() {
    return {
      isGeneratingPDF: false,
      prices: {
        full_books: 150.00,
        full_videos: 200.00,
        full_simulated: 80.00,
        combo_vip: 350.00,
        single_book: 25.00,
        single_video: 35.00,
        single_simulated: 15.00
      },
      simulation: {
        purchase_mode: 'exact',
        selected_tier_index: 0,
        accesses: 100,
        wants_full_books: false,
        wants_full_videos: false,
        wants_full_simulated: false,
        wants_combo_vip: false,
        qty_single_books: 0,
        qty_single_videos: 0,
        qty_single_simulated: 0,
        discount_percent: 0
      },
      volumeTiers: []
    }
  },
  async mounted() {
    await this.loadPricing();
  },
  methods: {
    async loadPricing() {
      try {
        const response = await requestV2.get('/pricing');
        const data = response.data;

        if (data.prices && Object.keys(data.prices).length > 0) {
          this.prices = { ...this.prices, ...data.prices };
        }
        if (data.volumeTiers && data.volumeTiers.length > 0) {
          this.volumeTiers = data.volumeTiers;
        }
      } catch (err) {
        console.error('Erro ao carregar preços da API para o simulador:', err);
        // Busca os valores atualizados do admin salvos no Pricing.vue
        const savedPrices = localStorage.getItem('admin_prices');
        if (savedPrices) {
          try {
            this.prices = { ...this.prices, ...JSON.parse(savedPrices) };
          } catch (e) {
            console.error('Erro ao ler preços base para a calculadora', e);
          }
        }
        
        const savedTiers = localStorage.getItem('admin_tiers');
        if (savedTiers) {
          try {
            this.volumeTiers = JSON.parse(savedTiers);
          } catch (e) {
            console.error('Erro ao ler faixas', e);
          }
        }
      }
    },
    generatePDF() {
      this.isGeneratingPDF = true;
      const element = this.$refs.pdfContent;
      
      const opt = {
        margin:       0,
        filename:     `Proposta_Comercial_${new Date().getTime()}.pdf`,
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2, backgroundColor: '#ffffff', useCORS: true },
        jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
      };

      html2pdf().set(opt).from(element).save().then(() => {
        this.isGeneratingPDF = false;
      });
    }
  },
  computed: {
    effectiveAccesses() {
      if (this.simulation.purchase_mode === 'tier' && this.volumeTiers.length > 0) {
        const tier = this.volumeTiers[this.simulation.selected_tier_index];
        if (tier) return tier.max;
      }
      return this.simulation.accesses;
    },
    appliedVolumeDiscount() {
      if (!this.volumeTiers || this.volumeTiers.length === 0) return 0;
      
      if (this.simulation.purchase_mode === 'tier') {
        const tier = this.volumeTiers[this.simulation.selected_tier_index];
        return tier ? (tier.discount || 0) : 0;
      }

      const accesses = this.effectiveAccesses;
      const tier = this.volumeTiers.find(t => accesses >= t.min && accesses <= t.max);
      if (tier) return tier.discount || 0;
      
      const lastTier = this.volumeTiers[this.volumeTiers.length - 1];
      if (accesses > lastTier.max) return lastTier.discount || 0;
      
      return 0;
    },
    calculatedTotal() {
      let unitCostPerAccess = 0;

      if (this.simulation.wants_combo_vip) {
        unitCostPerAccess = this.prices.combo_vip;
      } else {
        if (this.simulation.wants_full_books) unitCostPerAccess += this.prices.full_books;
        if (this.simulation.wants_full_videos) unitCostPerAccess += this.prices.full_videos;
        if (this.simulation.wants_full_simulated) unitCostPerAccess += this.prices.full_simulated;

        unitCostPerAccess += (this.simulation.qty_single_books * this.prices.single_book);
        unitCostPerAccess += (this.simulation.qty_single_videos * this.prices.single_video);
        unitCostPerAccess += (this.simulation.qty_single_simulated * this.prices.single_simulated);
      }

      let subtotal = unitCostPerAccess * this.effectiveAccesses;

      // 1. Aplica desconto automático de Lote
      if (this.appliedVolumeDiscount > 0) {
        subtotal = subtotal * ((100 - this.appliedVolumeDiscount) / 100);
      }

      // 2. Aplica desconto manual de negociação
      if (this.simulation.discount_percent > 0) {
        let discountMultiplier = (100 - this.simulation.discount_percent) / 100;
        subtotal = subtotal * discountMultiplier;
      }

      return subtotal;
    },
    calculatedTotalMonthly() {
      return this.calculatedTotal / 12;
    }
  }
}
</script>

<style scoped>
.simulator-layout {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 30px;
}

.config-panel h3, .result-panel h3 {
  color: #FEC401;
  margin-top: 0;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
}

.config-panel h4 {
  color: #fff;
  margin-top: 25px;
  margin-bottom: 15px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #ccc;
}

.input-sim {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 1.1rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  color: #fff;
}

.checkbox-label input {
  width: 18px;
  height: 18px;
  accent-color: #FEC401;
}

.divider {
  border: none;
  border-top: 1px solid rgba(255,255,255,0.1);
  margin: 20px 0;
}

.form-group-inline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  background: rgba(0,0,0,0.1);
  padding: 10px;
  border-radius: 8px;
}

.input-small {
  width: 80px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.discount-group {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.result-panel {
  text-align: center;
  position: sticky;
  top: 20px;
  height: fit-content;
}

.result-price {
  font-size: 2.8rem;
  font-weight: bold;
  color: #2ecc71;
  margin: 20px 0;
}

.result-breakdown {
  text-align: left;
  background: rgba(0,0,0,0.2);
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.result-breakdown ul {
  padding-left: 20px;
  color: #ccc;
}

.note {
  font-size: 0.8rem;
  color: #aaa;
  margin-top: 15px;
  font-style: italic;
}

.btn-primary {
  background: #FEC401;
  color: #09105D;
  border: none;
  padding: 15px;
  font-weight: bold;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: transform 0.2s;
}

.btn-primary:hover {
  background: #e5b001;
  transform: translateY(-2px);
}

.w-100 {
  width: 100%;
}

.pdf-header {
  text-align: center;
  border-bottom: 2px solid #FEC401;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.pdf-header h3 {
  color: #FEC401;
  font-size: 1.5rem;
  margin: 0;
  border-bottom: none;
}

.pdf-header p {
  color: #ccc;
  font-size: 0.9rem;
  margin-top: 5px;
}

.text-highlight {
  color: #FEC401;
}

.pdf-wrapper {
  padding: 20px;
  background: transparent;
}

@media (max-width: 992px) {
  .simulator-layout {
    grid-template-columns: 1fr;
  }
}
</style>
